<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <div class="user-name font-weight-bolder mb-0">
          {{ org.displayName }}
        </div>
        <small class="org-name no-wrap text-truncate" style="max-width: 200px;">{{ userData.fullName }}</small>
        <div>
          <small class="user-status font-weight-bold" v-if="org.orgId">Merchant Id: {{org.orgId}}</small>
        </div>
      </div>
      <b-avatar
        size="40"
        :src="org.logo"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >

      </b-avatar>
    </template>

    <!-- <b-dropdown-item
      :to="{ name: 'pages-profile'}"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>Profile</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'apps-email' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="MailIcon"
        class="mr-50"
      />
      <span>Inbox</span>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item
      :to="{ name: 'apps-todo' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="CheckSquareIcon"
        class="mr-50"
      />
      <span>Task</span>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="copyOrgId"
    >
      <feather-icon
        size="16"
        icon="CopyIcon"
        class="mr-50"
      />
      <small>{{t('copyOrgId')}}</small>
    </b-dropdown-item> -->
    <b-dropdown-item
      v-if="userData.orgId"
      link-class="d-flex align-items-center"
      @click="copyMerchantId"
    >
      <feather-icon
        size="16"
        icon="CopyIcon"
        class="mr-50"
      />
      <small>{{t('copyMerchantId')}}</small>
    </b-dropdown-item>

    <b-dropdown-divider />
    <b-dropdown-item
      to="/apps-and-services"
      target="_blank"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="LinkIcon"
        class="mr-50"
      />
      <span>{{t('appsAndServices')}}</span>
    </b-dropdown-item>
    <b-dropdown-divider />
    
    
    <b-dropdown-item
      :to="{ name: 'pages-account-setting' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
        />
        <span>{{t('settings')}}</span>
    </b-dropdown-item>
      <b-dropdown-divider />
    <b-dropdown-item
      :to="'/apps/workflow/approvals/list'"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="ToggleRightIcon"
        class="mr-50"
      />
      <span>{{t('approvalCenter')}}</span>
    </b-dropdown-item>
    <b-dropdown-divider />
    <!-- <b-dropdown-item
      :to="{ name: 'pages-pricing' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="CreditCardIcon"
        class="mr-50"
      />
      <span>Pricing</span>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item
      :to="{ name: 'pages-faq' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="HelpCircleIcon"
        class="mr-50"
      />
      <span>FAQ</span>
    </b-dropdown-item> -->
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>{{t('logout')}}</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { initialAbility } from '@/libs/acl/config'
import commonApi from '@/services/api';
import eventBus from '@/services/event-bus'
import constants from '@/services/constants'
import useJwt from '@/auth/jwt/useJwt'
import { avatarText } from '@core/utils/filter'
import Utils from '@/utils/index'

export default {
  components: {
    ToastificationContent,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      userData: {
        fullName: '',
        mId: '',
        orgId: '',
        avatar: ''
      },
      org: {},
      avatarText,
    }
  },
  mounted(){
    eventBus.$on(constants.events.PROFILE_DATA_CHANGED, e=>{
      this.userData = { ...this.userData, ...e};
    });
    eventBus.$on(constants.events.ORG_DATA_CHANGED, e=>{
      this.org = { ...this.org, ...e};
    });
    eventBus.$on(constants.events.REFRESH_PROFILE_INFO, e=>{
      this.getUserDetail();
    });
    // this.getOrgDetailFromOrgId();

    // this.getMerchantInfo();
    this.userData = Utils.getUserData() || {};
    this.org = Utils.getOrgData() || {};
    this.getUserDetail();
  },
  methods: {
    goToOneStopPortal(){
      window.open(Utils.goToOneStopPortal(), '_blank');
    },
    async getUserDetail(){
      await commonApi.getUserAndOrg().then(res => {
          if(res.success){
              const { orgAccount = {}, user = {} } = res.data;
              this.userData = user.userInfo;
              this.org = orgAccount || {};
              localStorage.setItem('tz-cortex-org-user',JSON.stringify(orgAccount));
              localStorage.setItem('tz-cortex-user',JSON.stringify(this.userData));
          }
      }).catch(err=>{
        console.log(err)
      });
    },
    getOrgDetailFromOrgId(){
      const userData = Utils.getLocal('tz-cortex-user') || {};
      if(userData && userData.orgId){
        commonApi.orgDetail(userData.orgId.replaceAll('"','')).then(res=>{
          console.log(res.data);

          if(res.success) {
              this.org = res.data.orgAccount ? res.data.orgAccount : userData
            }
          }).catch(err=>{  console.log(err); });
      } else{
        // this.org = userData;
      }
    },
    getMerchantInfo(){
      commonApi.getMp().then(res=>{
        if(res.success && res.data){
          if(res.data.orgAccount){
            this.userData = res.data.orgAccount;
            localStorage.setItem('tz-cortex-org-user',JSON.stringify(this.userData));
          }
        }
      }).catch(err=>{
        console.log(err);
      })
    },
    copyMerchantId(){
      this.copy(this.userData.orgId);
    },
    copyOrgId(){
      this.copy(this.userData.orgId);
    },
    copy(text){
      this.$copyText(text).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('copied'),
            icon: 'BellIcon',
          },
        })
      }, () => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('failed'),
            icon: 'BellIcon',
          },
        })
      })
    },
    logout() {
      eventBus.$emit(constants.events.LOG_OUT, true);
      return true;

      // commonApi.logout().then(res=>{
      //   if(res.success){
      //     localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      //     localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

      //     // remove merchant data form localStorage
      //     localStorage.removeItem('tz-cortex-merchant-info')

      //     localStorage.removeItem('tz-cortex-token')
      //     // localStorage.removeItem('tz-cortex-env');

      //     // Remove userData from localStorage
      //     localStorage.removeItem('userData')

      //     // Reset ability
      //     this.$ability.update(initialAbility);

      //     // const prefix = location.href.includes('staging') || location.href.includes('localhost') ? "https://staging-" : "https://";

      //     // location = location.origin + '/login';
      //     this.$router.push('/login');
      //   }
      // }).catch(err=>{
      //   this.$toast(this.$t('failedToLogoutTryAgain'))
      // })

      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token

      // location = prefix + 'biz.tranzak.me/login?next=' + location.href;

      // Redirect to login page

    },
  },
  setup(props) {
    const { t } = useI18nUtils()

    return {
      // i18n
      t,
     }
  }
}
</script>
